export default {
  buttons: {
    login: 'Anmelden',
    resend_code: 'Code erneut per SMS senden',
  },
  placeholders: {
    code: 'Code',
  },
  labels: {
    not_receive_code: 'Keinen Code erhalten?',
  },
};
